import BlogCard from "../../components/blog/BlogCard";
import React from "react";
import content from "../../generated/content.json";
import { useLocale } from "../../i18n/LocaleProvider";
import { useSearchParams } from "react-router-dom";
import { useT } from "../../i18n/useT";

const BlogIndex = () => {
  const { lang } = useLocale();
  const t = useT();
  const [params] = useSearchParams();
  const tag = params.get("tag");
  const all = content.blog?.[lang] || [];
  const posts = tag
    ? all.filter(
        (p) =>
          Array.isArray(p.frontmatter.tags) && p.frontmatter.tags.includes(tag)
      )
    : all;

  return (
    <section className="container py-5 mt-5">
      <h1 className="mb-4">{t("sections.blog.title")}</h1>
      {tag && <p className="text-secondary">{t("blog.filterTag", { tag })}</p>}
      <div className="row g-4">
        {posts.map((post) => (
          <div className="col-md-6 col-lg-4" key={post.slug}>
            <BlogCard post={post} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default BlogIndex;
